var _path, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgKmd(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48 96c26.51 0 48-21.49 48-48S74.51 0 48 0 0 21.49 0 48s21.49 48 48 48z",
    fill: "#2B6680"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15 48a33 33 0 1066 .127v-.253a33.175 33.175 0 00-.903-7.541 3.54 3.54 0 10-6.886 1.64 25.934 25.934 0 11-19.197-19.186 3.54 3.54 0 001.64-6.886A32.996 32.996 0 0015 48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.68 23.862c-.048.045-.079.098-.124.146a5.218 5.218 0 00-1.402 3.12v.561c0 .13-.028.255-.042.384a9.425 9.425 0 01-12.235 8.053 12.14 12.14 0 00-11.148 2.91c-.12.112-.252.207-.37.325A12.21 12.21 0 0056.627 56.63c.505-.512.963-1.07 1.368-1.665a12.205 12.205 0 001.868-9.813 9.374 9.374 0 01-.18-.665c0-.033-.02-.064-.028-.098a9.428 9.428 0 018.397-11.515c.07 0 .138-.02.208-.022.199 0 .398-.023.597-.023h.048a5.224 5.224 0 003.224-1.517c.205-.212.392-.441.56-.684a5.26 5.26 0 00-8.007-6.762"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKmd);
export default __webpack_public_path__ + "static/media/kmd.c97be842663e811d1a6e00bd0885e53c.svg";
export { ForwardRef as ReactComponent };